import type { ModelPriceView } from './types';

/**
 * Builds a `model_key → price` lookup from the organization-wide price list
 * (spec 092 data-model.md "Derived: ModelPriceLookup").
 *
 * A pure function, memoized at the call site: computed once per fetch rather
 * than re-scanned per row (constitution §2.3).
 */
export function buildModelPriceLookup(
  prices: ModelPriceView[],
): Map<string, ModelPriceView> {
  const lookup = new Map<string, ModelPriceView>();
  for (const price of prices) {
    lookup.set(price.model_key, price);
  }
  return lookup;
}
